module.exports = __webpack_public_path__ + "static/media/parramatta-eidsteddfod.46c3cfdb.png";